import React from 'react';

import FundSelect from './FundSelect';

const AddIndirectSubscription = () => {
    return <FundSelect isIndirect />;
};

export default AddIndirectSubscription;
